// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Sk-ImgWrapper-module--cls1--FSkW0","cls2":"Sk-ImgWrapper-module--cls2--2RHos Sk-ImgWrapper-module--cls1--FSkW0"};